import { ApiError } from 'api/http/types';
import { WirePolicyResponse, WireProduct } from 'scenes/common/api/quote/types';
import { PaymentMethod, PaymentWhen } from 'scenes/common/types';
import { ApiState } from '../common/helpers/apiData/types';

export enum CoverType {
  Unspecified = '',
  Comprehensive = 'Comprehensive',
  ComprehensivePlus = 'Comprehensive Plus',
  ThirdPartyFireAndTheft = 'Third Party Fire And Theft',
  ThirdPartyPropertyDamage = 'Third Party Property Damage',
  Building = 'Building',
  BuildingAndContents = 'Building & Contents',
  Contents = 'Contents',
}

export type WireOtherDetailsRequest = {
  description: string;
  risk: string;
  office: string;
  email?: string;
};

export type WireOtherDetailsResponse = WireOtherDetailsRequest & {
  eDoc: boolean;
};

type QuoteDates = {
  inception: string; // YYYY-MM-DD - date of coverage start period
  expiry: string; // YYYY-MM-DD - date quote expires (usually one year after effective date)
  effective: string; // YYYY-MM-DD - date of coverage start period
};

export enum RenewalStatus {
  Dishonour = 'Dishonour',
  Renewal = 'Renewal',
}

export type WirePolicyRetrieveResponse = WirePolicyResponse & {
  renewalStatus: RenewalStatus;
  otherDetails: WireOtherDetailsResponse;
  postcode: string;
};

export type Address = {
  fullName: string;
  suburb: string;
  state: string;
  postcode?: string;
};

export type WirePolicyParty = {
  email: string;
};

export type WirePremium = {
  id: string;
  gross: number;
  sd: number;
  fsl: number;
  gst: number;
  total: number;
};

export type Payment = {
  paymentMethod: PaymentMethod;
  paymentWhen: PaymentWhen;
  receipt: string;
  contactEmailAddress?: string;
};

export type PaymentPayload = {
  brand: string;
  policyNumber: string;
  policyReference: string;
  policyStatus: string;
  policyStatusMsg: string;
  receiptNumber: string;
  targetStatus: string;
};

export type ErrorPayload = {
  code?: string;
  msg?: string;
  id?: string;
  ref?: string;
  type?: string;
};

export type ErrorStore = {
  error: ApiError<ErrorPayload>;
  errorOccuredAt: string;
};

export type PaymentState = {
  product: WireProduct;
  address?: Address;
  coverType: CoverType;
  policy: WirePolicyRetrieveResponse;
  premiums?: WirePremium[];
  error?: ErrorStore;
  loadingStatus: ApiState;
  payment: Payment;
};

export type ConfigState = {
  maintenancePage: boolean;
};
export interface Response {
  status: string;
  type: string;
}

export interface PolicyResponse extends Response {
  payload: PolicyPayload;
}

export interface BindResponse extends Response {
  payload: PaymentPayload;
}
export interface PolicyPayload {
  brand: string;
  version: string;
  premiums?: WirePremium[];
  addresses?: AddressesEntity[] | null;
  coverType: string;
  status: string;
  policy: Policy;
}
export interface PremiumsEntity {
  id: string;
  gross: number;
  sd: number;
  fsl: number;
  gst: number;
  total: number;
}
export interface AddressesEntity {
  id: string;
  fullName: string;
  suburb: string;
  state: string;
  postcode: string;
}
export interface Policy {
  number: string;
  reference: string;
  status: string;
  partyRefId?: string[] | null;
  dates: Dates;
  renewalStatus: string;
  premiumRefId: string;
  addressRefId: string;
  otherDetails: WireOtherDetailsResponse;
}
export interface Dates {
  inception: string;
  expiry: string;
  effective: string;
}
export interface OtherDetails {
  description: string;
  risk: string;
  office: string;
  eDoc: boolean;
}
export interface PartiesEntity {
  id: string;
  email: string;
}
